import { useLang } from "@/i18n/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div className="overflow-hidden bg-ink border-y border-white/5 py-6 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display text-xl sm:text-2xl font-bold tracking-tight text-white/25 px-8">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-dblue to-electric" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
